import React from 'react';
import styled from 'styled-components';
import {
  Heading,
  Input,
  Option,
  Select,
} from '@alefeducation/ui-elements-library-core';
import FormControlContainer from './FormControlContainer';
import { Organisation } from '../../../apollo/queries';
import { ROLE_INFORMATION_TITLE } from '../../../utils/constants';

const StyledRoleInformation = styled.div`
  padding: 24px 24px 32px;
  border-bottom: 1px solid ${({ theme }: any) => theme.colors.primary[10]};

  > div {
    width: 80%;
  }
`;

const Flex = styled.div`
  display: flex;
  column-gap: 24px;
  margin-bottom: 32px;

  > div {
    width: 50%;
  }

  #select {
    height: 40px;
  }
`;

const StyledTitle = styled(Heading)`
  margin-bottom: 16px;
`;

type Props = {
  organisations: any[];
  selectedOrganisation: Pick<Organisation, 'name' | 'code'>;
  roleName: string;
  roleDescription: string;
  isEdit?: boolean;
  onRoleDescriptionChange(value: string): void;
  onRoleNameChange(value: string): void;
  onSelectedOrganisationChange(org: Pick<Organisation, 'name' | 'code'>): void;
};

const RoleInformation = ({
  organisations,
  roleName,
  selectedOrganisation,
  roleDescription,
  isEdit,
  onRoleDescriptionChange,
  onRoleNameChange,
  onSelectedOrganisationChange,
}: Props) => {
  return (
    <StyledRoleInformation data-testid="create-role-information">
      <StyledTitle variant="heading-small">
        {ROLE_INFORMATION_TITLE}
      </StyledTitle>

      <Flex>
        <FormControlContainer title="Select Organization *" disabled={isEdit}>
          <Select
            onSelectChange={() => {}}
            selectedOption={selectedOrganisation.name}
            data-testid="select-organisation"
            placeholder=""
            searchable
          >
            {organisations.map((org: any) => (
              <Option
                onClick={() => onSelectedOrganisationChange(org)}
                key={org.code}
              >
                {org.name}
              </Option>
            ))}
          </Select>
        </FormControlContainer>

        <FormControlContainer title="Role Name *">
          <Input
            name="role-name"
            value={roleName}
            onChange={(e) => {
              onRoleNameChange(e.target.value);
            }}
            data-testid="input-role-name"
          />
        </FormControlContainer>
      </Flex>

      <FormControlContainer title="Role Description *">
        <Input
          name="role-description"
          value={roleDescription}
          onChange={(e) => {
            onRoleDescriptionChange(e.target.value);
          }}
          data-testid="input-role-description"
        />
      </FormControlContainer>
    </StyledRoleInformation>
  );
};

export default RoleInformation;
